import { MediaQuery } from '@grandvisionhq/common';

/**
 * List of breakpoint names supported by Bloomreach. By using this list, components will always be visible
 * in any new breakpoint by default (no option to hide them until Bloomreach supports the new breakpoint)
 * If a breakpoint ever gets removed/replaced in the original enum, Bloomreach needs to be updated first to support the change
 */ const supportedBreakpoints = [
    MediaQuery.BreakpointName.PHONE,
    MediaQuery.BreakpointName.TABLET_PORTRAIT,
    MediaQuery.BreakpointName.TABLET_LANDSCAPE,
    MediaQuery.BreakpointName.DESKTOP, 
];
const isComponentVisible = (breakpoint, visibility)=>!visibility || !supportedBreakpoints.includes(breakpoint) || visibility.includes(breakpoint)
;
function useBreakpointVisibility({ component , page  }) {
    const breakpoint = MediaQuery.useBreakpoint();
    const preview = page === null || page === void 0 ? void 0 : page.isPreview();
    const { visibility  } = component === null || component === void 0 ? void 0 : component.getModels();
    return preview || isComponentVisible(breakpoint, visibility);
}

export { useBreakpointVisibility };
//# sourceMappingURL=use-breakpoint-visibility.js.map
